<div class="tw-flex tw-flex-row tw-items-center tw-flex-wrap tw-justify-between tw-px-3 tw-text-center tw-font-body">
  <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-h-18">
    <div
      [ngClass]="isMultiMessage ? '-tw-translate-y-[60px]' : '-tw-translate-y-[25px]'"
      class="tw-w-full tw-bg-orange-50 tw-border tw-border-orange-400 tw-px-4 tw-py-4 tw-text-left tw-rounded-xl">

      <div class="tw-flex tw-justify-start tw-items-start"
           [class.tw-mb-2]="isMultiMessage">
        <img src="/assets/icons/warning.svg"
             class="tw-w-4 tw-h-4 tw-mr-1 tw-mt-0.5"
             alt="warning_icon" />
        @switch (uiCode) {
          @case (InvalidPhotoUiCode.FACE_NOT_FOUND) {
            <h1 class="tw-text-300">
              <span i18n="@@faceNotFound"
                    class="tw-text-orange-400 tw-font-bold">Face not found,</span>
              <span i18n="@@retakePhotoForResults"
                    class="tw-text-gray-700 tw-ml-1">Please retake photo to get your skin analysis results.</span>
            </h1>
          }
          @case (InvalidPhotoUiCode.BLUR_IMAGE) {
            <h1 i18n="@@imageNotClear"
                class="tw-text-orange-400 tw-text-400 tw-font-bold">Image Not Clear</h1>
          }
          @case (InvalidPhotoUiCode.DARK_IMAGE) {
            <h1 i18n="@@improperLighting"
                class="tw-text-orange-400 tw-text-400 tw-font-bold">Improper lighting</h1>
          }
          @default {
            <h1 i18n="@@faceNotVisibleClearly"
                class="tw-text-orange-400 tw-text-400 tw-font-bold">Face not visible clearly</h1>
          }
        }
      </div>

      <!-- Subtitle + Instructions (multi-message only) -->
      @if (isMultiMessage) {
        @switch (uiCode) {
          @case (InvalidPhotoUiCode.DARK_IMAGE) {
            <h1 i18n="@@retakePhotoLighting"
                class="tw-text-200 tw-mb-2">Retake photo, after moving to a place with:</h1>
          }
          @default {
            <h1 i18n="@@retakePhoto"
                class="tw-text-200 tw-mb-2">Retake photo, by trying the following things:</h1>
          }
        }
        <div class="tw-text-200 tw-pl-2">
          @switch (uiCode) {
            @case (InvalidPhotoUiCode.BLUR_IMAGE) {
              <h1>1. <span i18n="@@cleanCamera">Clean your camera</span></h1>
              <h1>2. <span i18n="@@dontMove">Don't move while taking picture</span></h1>
              <h1>3. <span i18n="@@useBackCamera">Use back camera</span></h1>
            }
            @case (InvalidPhotoUiCode.DARK_IMAGE) {
              <h1>1. <span i18n="@@equalLighting">Equal lighting all over face</span></h1>
              <h1>2. <span i18n="@@notTooBrightNotTooDark">Not too bright and not too dark lighting</span></h1>
              <h1>3. <span i18n="@@useBackCamera">Use back camera</span></h1>
            }
            @default {
              <h1>1. <span i18n="@@fitFaceInOval">Fit your face in the oval</span></h1>
              <h1>2. <span i18n="@@cleanCamera">Clean your camera</span></h1>
              <h1>3. <span i18n="@@useBackCamera">Use back camera</span></h1>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
